(function ($) {
  Drupal.behaviors.hotspotProductGridFormatterV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $template = $('.js-hotspot-product-formatter-v1', context);

      $template.each(function () {
        var $this = $(this);
        var $hotspot = $this.find('.js-hotspot-marker');
        var $hotProduct = $this.find('.js-hotspot-product-card');
        var $closer = $hotProduct.find('.js-hotspot-product-card-close');

        if (!$hotProduct.length) {
          return;
        }
        var leftPosition = 0;
        var leftOffset = 0;

        // open
        $hotspot.once().on('click', function () {
          var $this = $(this);
          var $currentHotProduct = $this.next($hotProduct);
          var screenWidth = window.screen.width;

          $hotspot.attr('aria-expanded', 'false');
          leftPosition = $this.offset().left;
          $hotProduct.removeClass('active').attr('aria-hidden', 'true').css({ left: '' });
          $this.attr('aria-expanded', 'true');
          $currentHotProduct.addClass('active').attr('aria-hidden', 'false');
          var hotProductWidth = $currentHotProduct.outerWidth();
          // hotspot floats outside on the left
          if (
            !$currentHotProduct.hasClass('hotspot-product__card--middle') &&
            leftPosition + 15 < hotProductWidth / 2
          ) {
            leftOffset = hotProductWidth / 2 - leftPosition + 15;
            $currentHotProduct.css({ left: leftOffset + 'px' });
          } else if (
            !$currentHotProduct.hasClass('hotspot-product__card--middle') &&
            leftPosition + hotProductWidth / 2 > screenWidth
          ) {
            // hotspot floats outside on the right
            leftOffset = leftPosition + hotProductWidth / 2 - screenWidth + 15;
            $currentHotProduct.css({ left: -1 * leftOffset + 'px' });
          }
          $('.js-product-brief-shades-item-link:visible', context)
            .once()
            .on('click', function (e) {
              e.preventDefault();
              var $this = $(this);

              $this.trigger('product.brief-loaded');
            });
        });

        // close
        $closer.once().on('click', function (e) {
          e.preventDefault();
          var $this = $(this);

          $this.closest('.js-hotspot').attr('aria-expanded', 'false');
          $this
            .closest('.js-hotspot-product-card')
            .removeClass('active')
            .attr('aria-hidden', 'true');
        });
      });
    },
    attached: false
  };
})(jQuery);
